import Interface from './Interface';
import Statistics from './Statistics';
import Layout from './Layout';

export default {
    Interface, Statistics, Layout
};